import { render, staticRenderFns } from "./paperList.vue?vue&type=template&id=da0c42be&scoped=true"
import script from "./paperList.vue?vue&type=script&lang=js"
export * from "./paperList.vue?vue&type=script&lang=js"
import style0 from "./paperList.vue?vue&type=style&index=0&id=da0c42be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0c42be",
  null
  
)

export default component.exports